import { useState, useEffect, useContext } from 'react'
import classes from './ShowUploadedLanes.module.css'
import Axios from '../../../Axios'
import { Urls } from '../../../Urls'
import Pagination from 'react-js-pagination'
import ReactTooltip from 'react-tooltip'
import Modal from '../../Shared/PopupModal/PopupModal'
// import ProfileModal from '../../TransporterClientScreen/ProfileModal/ProfileModal'
// import Rating from 'react-rating'
import mixpanel from 'mixpanel-browser'
import { next_page } from '../Utility'
import { Activity, currentRequestTimeStamp } from '../../../Constants'
import Loader from '../../Loader'
import TableToExcelButton from '../../Shared/TableToExcelButton/TableToExcelButton'
import { ViewLSP } from '../BenchmarkMasterView/BenchMarkResults/BenchMarkResults'
import { MyCompanyProfileContext } from '../../../MyCompanyProfileContext'


const ShowUploadedLanes = ({
    excel_id = "",
    allowedLanes
}) => {
    const [lspLanes, setlspLanes] = useState([])
    const [show, setshow] = useState(false)
    const [skipactive, setskipactive] = useState(1)
    const [showlanes, setshowlanes] = useState([])
    const [lspload, setlspload] = useState(true)
    const { companySettingData } = useContext(MyCompanyProfileContext)
    // const [showtransporterdata, setshowtransporterdata] = useState([])
    const { userDetails } = useContext(UserApiContext);

    useEffect(() => {
        var payload = {
            "excel_id": excel_id,
            "email": userDetails.email
        }
        // console.log(payload)
        setshow(true)
        Axios.post(`${Urls.benchmarnow}?field=custom_benchmark_applied`, payload)
            .then(res => {
                // console.log(res)
                setlspLanes(res.data)
                var temp = []
                for (var i = 0; i < 5; i++) {
                    if (res.data[i])
                        temp.push(res.data[i])
                }
                getTransporterList(temp)
                setshowlanes(temp)
                setshow(false)
                next_page({ "data": true, "excel_id": excel_id, "key": "benchmark_seen" })
            })
            .catch(err => {
                console.log(err)
                setshow(false)
            })
    }, [excel_id])

    const numberWithCommas = (x) => {
        if (x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }

    const termsClick = () => {
        mixpanel.track(`User has clicked on terms of use and disclaimers`, {
            ApplicationName: `${Urls.mixpanelappname}`,
            ScreenName: 'LoRRI-Benchmark',
            ModuleName: 'benchmark_page',
            ActivityLog: 'userClickedTermsOfUseAndDisclaimers',
            Data: `None`,
            Definition: `User has clicked on terms of use and disclaimers`,
            ActivityType: 'event_view',
            UserName: userDetails?.user_name,
            UserEmail: userDetails?.email,
            CompanyName: userDetails.company_name
                ? userDetails.company_name
                : userDetails.email
                    ? userDetails.email.split("@")[1].split(".")[0]
                    : ""
        });
    }

    // const ViewLSP = ({item}) =>{
    //     return <div style={{ width: '104%'}}>
    //         <p style={{lineHeight: '12px', fontSize: '14px'}}>
    //             Showing <b>{item.transporter_list ? item.transporter_list.length:0 } of {item.dashboard && item.dashboard[1] ? item.dashboard[1].value: 0}</b> Transporters</p>
    //         <p style={{fontSize:'12px', lineHeight:'13px'}}>(Please click on the link to view the Master RFI/ LoRRI Profile)</p>
    //          {item && item.transporter_list && item.transporter_list.length >0 ? item.transporter_list.map((tname,index)=>{
    //                 return <div key={index} className="row" style={{borderBottom:'1px solid lightgrey'}}>
    //                     <div className="col-md-8">
    //                         <ProfileModal 
    //                             transporter_list={item.transporter_list}
    //                             transporter_id={tname.transporter_id}
    //                             transporter_name={tname.transporter_name}
    //                             screenName={'My Freight Benchmark'}
    //                             moduleName={'Benchmark Results'}
    //                             buttonClass={`${classes['own-modal-style']} btn-link`}
    //                         />
    //                     </div>
    //                     <div className="col-md-4">
    //                     <Rating
    //                         initialRating={tname.overall_rating}
    //                         readonly={true}
    //                         style={{float: 'right'}}
    //                         emptySymbol={`fa fa-star ${classes['star-1']}`}
    //                         fullSymbol={`fa fa-star ${classes['star-1-selected']}`} />
    //                     </div>
    //                 </div>
    //             }): "No Transporter Found For this Lane"}
    //         </div>
    // }

    const getOnChange = (e) => {
        var temp = []
        for (var i = ((e - 2) * 5) + 5; i < (((e - 2) * 5) + 10); i++) {
            if (lspLanes[i])
                temp.push(lspLanes[i])
        }
        getTransporterList(temp)
        setshowlanes(temp)
        setskipactive(e)
    }

    const getTransporterList = (temp) => {
        setlspload(true)
        var payload = {
            "network": temp.map((i) => {
                return {
                    origin_coordinates: [i['olon'], i['olat']],
                    origin_name: i['ORIGIN NAME'] + ',' + i['ORIGIN DISTRICT'] + ',' + i['ORIGIN STATE'],
                    destination_name: i['DESTINATION NAME'] + ',' + i['DESTINATION DISTRICT'] + ',' + i['DESTINATION STATE'],
                    truck_type: i['CONSOLIDATED TRUCK TYPE'],
                    destination_coordinates: [i['dlon'], i['dlat']],
                }
            }),
            session_created_on: new Date().toISOString()
        }

        Axios.post(`${Urls.benchmarnow}?field=transporter_list`, payload)
            .then(res => {
                var lane_key = ""
                // setshowtransporterdata(res.data.network)
                temp = temp.map((item) => {
                    var temp_tranporter_dashboard = {}
                    res.data.network.filter(i => {
                        if (
                            i.origin_name === item['ORIGIN NAME'] + ',' + item['ORIGIN DISTRICT'] + ',' + item['ORIGIN STATE'] &&
                            i.destination_name === item['DESTINATION NAME'] + ',' + item['DESTINATION DISTRICT'] + ',' + item['DESTINATION STATE'] &&
                            i.truck_type === item['CONSOLIDATED TRUCK TYPE']
                        ) {
                            // console.log(i.transporter_dashboard)
                            temp_tranporter_dashboard = i.transporter_dashboard;
                            lane_key = item['ORIGIN NAME'] + " TO " + item['DESTINATION NAME'] + " " + item['CONSOLIDATED TRUCK TYPE'];
                            return true; // Return true to include the element in the filtered array
                        }
                        return false; // Explicitly return false for cases where the condition is not met
                    });

                    item.transporter_dashboard = temp_tranporter_dashboard
                    item.lane_key = lane_key
                    return item
                })
                setshowlanes(temp)
                // console.log(temp)
                setlspload(false)
            })
            .catch(err => {
                // setShow(false)
            })
        // Axios.post(`${Urls.benchmarnow1}?field=transporter_list`,payload)
        //     .then(res => {
        //         // console.log(res)

        //     })
        //     .catch((err) => {console.log(err)})
    }

    const getAllEnquiry = () => {
        document.getElementById('download_table').click()
        Activity([{ "screen": "My Freight Benchmark", "module": "Exit button", "user_activity": "User Clicked on Download Excel Button", "timestamp": currentRequestTimeStamp(), "userEmail": userDetails?.email, "userName": userDetails?.user_name, companyname: userDetails.company_name ? userDetails.company_name : userDetails.email ? userDetails.email.split("@")[1].split(".")[0] : "" }])
        mixpanel.track(`User Clicked on Download Excel Button`, {
            ApplicationName: `${Urls.mixpanelappname}`,
            ScreenName: 'LoRRI-Benchmark',
            ModuleName: 'benchmark_page',
            ActivityLog: 'userClickedDownloadExcelButton',
            Data: `None`,
            Definition: `User Clicked on Download Excel Button`,
            ActivityType: 'event_view',
            UserName: userDetails?.user_name,
            UserEmail: userDetails?.email,
            CompanyName: userDetails.company_name
                ? userDetails.company_name
                : userDetails.email
                    ? userDetails.email.split("@")[1].split(".")[0]
                    : ""
        });
    }

    const goToStart = () => {
        if (window.confirm('Please confirm if you wish to exit this benchmark session, as the session will expire thereafter')) {
            Activity([{ "screen": "My Freight Benchmark", "module": "Exit button", "user_activity": "User Clicked on Exit Button", "timestamp": currentRequestTimeStamp(), "userEmail": userDetails?.email, "userName": userDetails?.user_name, companyname: userDetails.company_name ? userDetails.company_name : userDetails.email ? userDetails.email.split("@")[1].split(".")[0] : "" }])
            mixpanel.track(`User has clicked on exit button`, {
                ApplicationName: `${Urls.mixpanelappname}`,
                ScreenName: 'LoRRI-Benchmark',
                ModuleName: 'benchmark_page',
                ActivityLog: 'userClickedExitButton',
                Data: `None`,
                Definition: `User has clicked on exit button`,
                ActivityType: 'event_view',
                UserName: userDetails?.user_name,
                UserEmail: userDetails?.email,
                CompanyName: userDetails.company_name
                    ? userDetails.company_name
                    : userDetails.email
                        ? userDetails.email.split("@")[1].split(".")[0]
                        : ""
            });
            window.location.reload()
        }
    }

    return (
        <div>
            <Loader show={show} />
            <div className={classes['med-div']}>
                <span id="definition" data-tip data-for="definition"><i className="btn btn-primary fa fa-info"></i></span>
                <ReactTooltip className={`${classes['tooltip']}`} id="definition" place="bottom" effect="solid">
                    <div >
                        <b>Median:</b> <br />The central value of freight based on available freight rates<br />
                        {/* <b>Max:</b> <br/>The maximum value of freight based on available freight rates<br/> */}
                        <b>Note:</b> <br />Available Contracted Freight rates in LoRRI Benchmark are based on industry standard terms and conditions and may vary based on your specific terms, conditions and volume requirements
                    </div>
                </ReactTooltip>
                <button onClick={() => getAllEnquiry()} style={{ marginLeft: '10%' }} className="btn btn-sm btn-primary tr-button1"><span><i className="fa fa-download" style={{ marginRight: '5px' }} />Download Excel</span></button>
                {/* <ReactHTMLTableToExcel
                id="download_table"
                className="btn btn-sm btn-primary d-but"
                table="Benchmark_Table"
                filename="Benchmark_Lanes"
                sheet="tablexls"
                buttonLabel={<span><i className="fa fa-download" style={{ marginRight: '5px' }} />Download Excel</span>}
            /> */}
                <TableToExcelButton
                    buttonId="download_table"
                    tableId="Benchmark_Table"
                    filename="Benchmark_Lanes"
                    sheet="tablexls"
                    className="btn btn-sm btn-primary d-but"
                    label={
                        <span>
                            <i className="fa fa-download" style={{ marginRight: '5px' }} />
                            Download Excel
                        </span>
                    }
                />
                <button className={`btn btn-sm btn-primary ${classes['s-exit']}`} style={{ marginLeft: '10%' }} onClick={e => goToStart()}>Exit</button>
            </div>

            {lspLanes && lspLanes.length > 0 ?
                <table id="Benchmark_Table" style={{ display: 'none' }}>
                    <thead>
                        <tr>
                            <th style={{ width: '7%', textAlign: 'center' }}>Sr. No.</th>
                            <th style={{ width: '15%', textAlign: 'center' }}>Origin</th>
                            <th style={{ width: '15%', textAlign: 'center' }}>Destination</th>
                            <th style={{ width: '15%', textAlign: 'center' }}>Truck Type</th>
                            <th style={{ width: '15%', textAlign: 'center' }}>Median Rate `(${companySettingData?.default_currency?.default_currency?.cc ?? "INR"})`</th>
                            <th style={{ width: '15%', textAlign: 'center' }}>Maximum Rate `(${companySettingData?.default_currency?.default_currency?.cc ?? "INR"})`</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lspLanes.map((item, index) => {
                            return <tr><td>{index + 1}</td>
                                <td>{item['ORIGIN NAME']},{item['ORIGIN DISTRICT']},{item['ORIGIN STATE']}</td>
                                <td>{item['DESTINATION NAME']}, {item['DESTINATION DISTRICT']}, {item['DESTINATION STATE']}</td>
                                <td>{item['CONSOLIDATED TRUCK TYPE']}</td>
                                <td>{item['Median Rate']}</td>
                                <td>{item['Maximum Rate']}</td>
                            </tr>
                        })}
                    </tbody>
                </table>
                : null}

            {allowedLanes > 0 ? <div className={classes['t-div']}>
                <table className={classes['table-s']}>
                    <thead style={{ textAlign: 'center' }}>
                        <tr>
                            <th style={{ width: '7%', textAlign: 'center' }} >Sr. No.</th>
                            <th style={{ width: '15%', textAlign: 'center' }}>Origin</th>
                            <th style={{ width: '15%', textAlign: 'center' }}>Destination</th>
                            <th style={{ width: '15%', textAlign: 'center' }}>Truck Type</th>
                            <th style={{ width: '15%', textAlign: 'center' }} >Median Rate (₹)</th>
                            <th style={{ width: '15%', textAlign: 'center' }}>
                                Maximum Rate (₹)
                            </th>
                            <th >View Transporters </th>
                        </tr>

                    </thead>
                </table>
                <div style={{ overflowY: 'scroll', maxHeight: '50vh' }}>
                    <table className={classes['table-s']}>
                        <tbody style={{ overflow: 'auto' }}>
                            {showlanes && showlanes.length > 0 ?
                                showlanes.map((item, index) => {
                                    return (
                                        <>
                                            <tr key={index}>
                                                <td style={{ width: '7%', textAlign: 'center' }}>{index + 1}</td>
                                                <td style={{ width: '15%', textAlign: 'center' }}>{item['ORIGIN NAME'] ? <span>{item['ORIGIN NAME']},{item['ORIGIN DISTRICT']}, {item['ORIGIN STATE']}</span> : ''}</td>
                                                <td style={{ width: '15%', textAlign: 'center' }}>{item['DESTINATION NAME'] && item['DESTINATION DISTRICT'] && item['DESTINATION STATE'] ? <>{item['DESTINATION NAME']}, {item['DESTINATION DISTRICT']}, {item['DESTINATION STATE']}</> : ''}</td>
                                                <td style={{ width: '15%', textAlign: 'center' }}>
                                                    {
                                                        item['CONSOLIDATED TRUCK TYPE'] ? <span>
                                                            {item['CONSOLIDATED TRUCK TYPE']}
                                                        </span> : ''

                                                    }
                                                </td>
                                                <td style={{ paddingLeft: '4%', width: '15%', textAlign: 'center' }}><div className={`${classes['medmaxdata']}`}> {item['Median Rate'] ? <>&#8377; {numberWithCommas(item['Median Rate'])}</> : '-'}</div></td>

                                                <td style={{ paddingLeft: '4%', width: '15%', textAlign: 'center' }}>
                                                    <div className={`${classes['medmaxdata']}`}>
                                                        {
                                                            item["Maximum Rate"] ? (
                                                                <>
                                                                    {item["Maximum Rate"] !== "Under Validation"
                                                                        ? `₹ ${numberWithCommas(item["Maximum Rate"])}`
                                                                        : item["Maximum Rate"]}
                                                                </>
                                                            ) : "-"
                                                        }
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        {lspload ? <div className={`${classes['my-row']}`}>

                                                            <div className={`${classes['my-loader']}`} />
                                                            <span style={{ textAlign: 'left', marginLeft: '7%', marginTop: '-3%' }}>
                                                                Fetching Transporters, Please Wait...
                                                            </span>
                                                        </div> :

                                                            <Modal
                                                                buttonLabel={<span style={{ fontSize: '14px' }}>View Transporters
                                                                    ({item.transporter_dashboard
                                                                        && item.transporter_dashboard.dashboard
                                                                        && item.transporter_dashboard.dashboard[1] ?
                                                                        item.transporter_dashboard.dashboard[1].value
                                                                        : 0})
                                                                </span>}
                                                                buttonClass="btn btn-primary"
                                                                style={{ width: 'fit-content' }}
                                                                content={<ViewLSP item={item.transporter_dashboard} />}
                                                                title={item.laneKey}
                                                                titleSize='sm'
                                                                size='md'
                                                                variant='popover'
                                                                id="editenquiry"
                                                                screenName="My Freight Benchmark"
                                                                moduleName="View LSP"
                                                                activityName="View LSP Button Clicked"
                                                            />
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                        </>
                                    )
                                })
                                : null}
                        </tbody>
                    </table>
                </div>
                <center>
                    <Pagination
                        activePage={skipactive}
                        itemsCountPerPage={5}
                        totalItemsCount={lspLanes.length}
                        onChange={e => getOnChange(e)}
                        itemClass="page-item"
                        linkClass="page-link"
                        hideDisabled
                    />
                </center>
                <center style={{ position: 'absolute', bottom: '1%', width: '100%' }}>
                    <a href="https://lntermsandconditions.blob.core.windows.net/tnc/benchmark_tnc.html" rel="noopener noreferrer" target="_blank" onClick={(e) => termsClick(e)}>LoRRI Benchmark Terms of Use and Disclaimers</a>
                </center>
            </div> :
                <div></div>}
        </div>
    )
}

export default ShowUploadedLanes
